import type { CompanyLegalInfo } from "@/types/legal";

const COMPANY_LEGAL_INFO_BY_COUNTRY: Record<string, CompanyLegalInfo> = {
  US: {
    companyName: "Luminarys Inc.",
    address: "9805 Double R Blvd, Suite 300, Reno, Nevada 89521, USA",
    country: "USA",
    registrationNumber: "File number - 10524261",
  },
  OTHER: {
    companyName: "Imponilox Limited",
    address: "Themistokli Dervi 39, 1st floor, Office 104, 1066, Nicosia, Cyprus",
    country: "Cyprus",
    registrationNumber: "reg. No. HE 405373",
  },
};

const isCountrySupported = (country: string) => country in COMPANY_LEGAL_INFO_BY_COUNTRY;

export const getCompanyLegalInfo = (countryCode?: string | null): CompanyLegalInfo => {
  const country = countryCode ?? "";

  if (!isCountrySupported(country)) {
    return COMPANY_LEGAL_INFO_BY_COUNTRY.OTHER;
  }

  return COMPANY_LEGAL_INFO_BY_COUNTRY[country];
};
